import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getRelationship = get('guest.components.relationship');

export const getRelationshipById = createSelector(
  getRelationship,
  get('guestById')
);

export const getRelationshipForId = createSelector(
  (_, guestId) => guestId,
  getRelationshipById,
  get
);

export const getFetching = createSelector(getRelationship, get('fetching'));

export const getFetched = createSelector(getRelationship, get('fetched'));
